import { formatMoney } from "../tools/moneyFormats";

export default function() {
  class ProductSticky extends HTMLElement {
    constructor() {
      super();

      this.select = this.querySelector('custom-select');
      if (this.select) this.input = this.select.inputHidden;
      this.section = this.closest('[data-parent-sticky]');
      this.productCard = this.section.querySelector('product-card');
      this.btn = this.querySelector('.add-to-checkout');
      this.price = {
        price: this.querySelector('[data-price]'),
        comparePrice: this.querySelector('[data-price-compare]'),
        priceSave: this.querySelector('[data-price-save]')
      }
      this.init();
    }

    init() {
      if (!this.productCard) return;
      if (this.btn) this.btn.addEventListener('click', this.addToCart)
      if (this.select) this.select.addEventListener('change', this.changeVariantProductCard.bind(this));

      if (this.section) {
        this.showHideElement();
        window.addEventListener('scroll', window.debounce(this.showHideElement.bind(this), 100))
      };
    }

    changeVariant(title) {
      const variantAvailable = this.productCard.currentVariant.available;

      if(this.input.value !== title) {
        this.select.querySelector(`[data-option-value="${title}"] button`).click();
        this.changeButton(variantAvailable).bind(this);
      }
    }

    showHideElement() {
      const section_position = this.section.getBoundingClientRect();

      if (section_position.bottom < 0) {
        this.style.opacity = '1';
        this.style.transform = "translateY(0)";
      } else {
        this.style.opacity = '0';
        this.style.transform = "translateY(100%)";
      }
    }

    changeButton (boolean) {
      const $addText = this.btn.querySelector('.product-form__submit-text');
      const $soldOut = this.btn.querySelector('.sold-out-message');

      if (boolean === false ) {
        this.btn.setAttribute('disabled', 'disabled');
        $soldOut.classList.remove('visually-hidden');
        $addText.classList.add('visually-hidden');
      } else {
        $addText.classList.remove('visually-hidden');
        $soldOut.classList.add('visually-hidden');
        this.btn.removeAttribute('disabled');
      }
    }

    changePrice(price, comparePrice, priceSave) {
      if (this.price.price) {
        this.price.price.innerHTML = formatMoney(price);
      }

      if (this.price.comparePrice && comparePrice) {
        this.price.comparePrice.innerHTML = formatMoney(comparePrice);
      }

      if (this.price.priceSave && priceSave && priceSave > 0) {
        this.price.priceSave.innerHTML = 'Save '+formatMoney(priceSave);
      }
    }

    changeVariantProductCard () {
      this.productCard.currentVariant = this.productCard.changeCurrentVariant(this.input.value, this.productCard.productForm.product.variants);
      this.productCard.changeColorSwatch();
      this.productCard.updateCheckedVariants();

      const price = this.productCard.currentVariant.price,
          comparePrice = this.productCard.currentVariant.compare_at_price,
          savePrice = this.productCard.currentVariant.compare_at_price - this.productCard.currentVariant.price,
          variantAvailable = this.productCard.currentVariant.available;


      this.changePrice(price, comparePrice, savePrice);
      this.changeButton(variantAvailable);
    }
  }
  customElements.define('product-sticky', ProductSticky);
}